

<div class="app-background">

    <router-outlet>
    </router-outlet>
</div>
